<p-table #dt [value]="matchingPeopleResult$ | async" [columns]="matchingPeopleResultCols" [paginator]="true" [rows]="defaultTableRows" dataKey="PersonID" [autoLayout]="true" responsiveLayout="scroll" (sortFunction)="peopleResultsSort($event)" [customSort]="true">
  <ng-template pTemplate="caption">
    <div class="p-2 fw-bold text-center">Find Existing People Result</div>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th *ngFor="let col of columns" scope="col" [pSortableColumn]="col.field">
        <div class="p-d-flex p-jc-between p-ai-center">
          {{col.header}}
          <p-sortIcon [field]="col.field" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
        </div>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-columns="columns">
    <tr>
      <td>
        <ng-container *ngFor="let fbiNum of rowData.ENESS_XREF_PeopleFBIFileNumbers">{{fbiNum.FBIFileNumber}}<br /></ng-container>
      </td>
      <td>
        <ng-container *ngFor="let stateNum of rowData.ENESS_XREF_PeopleStateIDNumbers">
          {{stateNum.StateAbbreviation?.concat(':')}} {{stateNum.StateIDNumbers}}<br />
        </ng-container>
      </td>
      <td>
        <button type="button" class="btn btn-sm btn-link" aria-label="{{'Person '+ rowData.LastName +' details'}}" tabindex="0" (click)="viewPersonDetails(rowData.PersonID)">{{ rowData.LastName }}</button>
      </td>
      <td>{{ rowData.FirstName }}</td>
      <td>{{ rowData.DateOfBirth | date:"MM/dd/yyyy"}}</td>
      <td>{{ rowData.SSN | ssnFormat}}</td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
      <td [attr.colspan]="columns.length">
        No records found.
      </td>
    </tr>
  </ng-template>
</p-table>
